module.exports = __webpack_public_path__ + "media/src/images/media_top-20a952611b9ec0a7e83cf785c7eb6ee1.jpg";